module.exports = __webpack_public_path__ + "img/add-arrival-requested-climbing-table-icon.dd7efba9.svg";